import { render, staticRenderFns } from "./CarDescription.vue?vue&type=template&id=ac73ada4&"
import script from "./CarDescription.vue?vue&type=script&lang=js&"
export * from "./CarDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports